import Vue from 'vue';
import Vuex from 'vuex';
import naviList from './modules/naviList';
import user from './modules/user';
import group from './modules/group';
import test from './modules/test';
import upload from './modules/upload';
import asset from './modules/asset';
import search from './modules/search';
import dashboard from './modules/dashboard';
import objectData from './modules/objectData';
import snackbar from './modules/snackbar';
import livestatus from './modules/livestatus';
import menuItems from './modules/menuItems';

const DEFAULT_LANGUAGE_OPTIONS = [
  { code: 'KOR', label: '한국어' },
  { code: 'ENG', label: 'English' },
  { code: 'CHN', label: '中文' },
  { code: 'JPN', label: '日本語' },
];

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: sessionStorage.getItem('selectedLanguage') || null,
    translations: {},
    languageOptions: DEFAULT_LANGUAGE_OPTIONS,
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
      if (lang) {
        sessionStorage.setItem('selectedLanguage', lang);
      } else {
        sessionStorage.removeItem('selectedLanguage');
      }
    },
    setTranslations(state, translations) {
      state.translations = translations;
    },
    setLanguageOptions(state, options) {
      if (Array.isArray(options) && options.length) {
        state.languageOptions = options;
      } else {
        state.languageOptions = DEFAULT_LANGUAGE_OPTIONS;
      }
    }
  },
  getters: {
    currentLanguage: state => state.language || (state.languageOptions[0]?.code ?? 'KOR'),
    currentTranslations: state => state.translations,
    t: state => key => {
      const lang = state.language || state.languageOptions[0]?.code || 'KOR';
      return (state.translations[lang] && state.translations[lang][key]) || key;
    },
    availableLanguages: state => state.languageOptions,
  },
  modules: {
    naviList,
    user,
    group,
    test,
    upload,
    asset,
    search,
    dashboard,
    objectData,
    snackbar,
    livestatus,
    menuItems
  },
});
